import React from "react";
import './Header.scss';
import GlobalData from '../../data/global.js';
import OutputHTML from '../../helpers/OutputHTML.js';
import { Helmet } from 'react-helmet';
import { trackCustomEvent } from "../../helpers/tracking"
import IsNotDomestic from '../../helpers/IsNotDomestic';

function onClientClick(){
    let trackObject = {
        category: GlobalData.tracking.gaCategory,
        action: "Click",
        label: "Client logo header"
    }
    trackCustomEvent(trackObject)
}

export default function Header({headerClass, isSticky}) {
  let header = GlobalData.header;

  function headerMarkup(params) {
    return (
<div className={`header ${headerClass}`}>
          <div className={`header__left_container`}>
            <div className={`header__left_container__logo_container`}>
              <img className={`header__left_container__bbc_logo`} src={header.bbc.logoPath} alt={header.bbc.alt}/>
            </div>
          </div>

          <div className={`header__right_container`}>
            <IsNotDomestic>
              <div className={`header__right_container__client_logo_container`}>
                <div className={`header__right_container__client_logo_copy`}>
                  <p dangerouslySetInnerHTML={ OutputHTML( header.client.copy)}></p>
                </div>
                <div className={`header__right_container__client_logo_wrapper`}>
                  <a onClick={() => {onClientClick()}} href={header.client.clientURL} target="_blank" rel="noreferrer">
                    <img className={`header__right_container__client_logo`} src={header.client.logoPath} alt={header.client.alt}/>
                  </a>
                </div>
              </div>
            </IsNotDomestic>
          </div>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>{ GlobalData.pageTitle }</title>
        <meta name="keywords" content={GlobalData.keywords}/>
        <meta name="description" content={GlobalData.pageDescription} />
        <meta property="og:url" content={GlobalData.metaData.urlPath} />
        <meta property="og:title" content={GlobalData.metaData.title} />
        <meta property="og:description" content={GlobalData.metaData.facebookDescription} />
        <meta property="og:image" content={GlobalData.metaData.facebookSocialImage} />
        <meta property="og:image:alt" content={GlobalData.metaData.imageAlt} />
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:title" content={GlobalData.metaData.title} />
        <meta name="twitter:description" content={GlobalData.metaData.twitterDescription}/>
        <meta name="twitter:image" content={GlobalData.metaData.twitterSocialImage} />
        <meta name="twitter:image:alt" content={GlobalData.metaData.imageAlt} />
      </Helmet>
      {(isSticky
        ?
        <>
          <div className={`header__sticky_filler`}>
            {headerMarkup()}
          </div>
          <div className={`header__sticky`}>
          {headerMarkup()}
          </div>
        </>
        :
        ""
      )}


    </>
  )
}